import { toast } from "react-toastify";
import { setTitle } from "../../../../helpers/MetaTag";
import { handleFilterChange } from "../../../../helpers";
import DeleteModal from "../../../../components/common/DeleteModal";

import { useDebounce } from "../../../../hooks/useDebounce";
import LimitSelect from "../../../../components/elements/LimitSelect";
import { useState } from "react";
import Search from "../../../../components/form/Search";
import Table from "../../../../components/elements/table/Table";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import Button from "../../../../components/form/Button";
import {
  organizationDelete,
  organizationList,
} from "../../../../services/organizationService";
import ManageOrganizationDrawer from "../../../../components/sections/admin/Organization/Drawer/ManageOrganizationDrawer";

const Organization = () => {
  setTitle("Organization");
  //   const { permission, status } = useGetPermission("pages");
  const [selectedItems, setSelectedItems] = useState([]);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 300);
  const queryClient = useQueryClient();
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    data: null,
  });
  const [filters, setFilters] = useState({
    limit: 10,
    page: 1,
    sortQuery: "-createdAt",
  });

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ["organization", filters, search],
    queryFn: async () => {
      const res = await organizationList({
        ...filters,
        ...(search && { keyword: search }),
      });
      if (res?.status !== 200) {
        toast.warning(res?.message);
      }
      return res?.docs;
    },
  });

  //   banner status change handler =================>
  //   const { mutate: statusChangeHandler, isPending: statusChangeInPending } =
  //     useMutation({
  //       mutationFn: async ({ id, status }) => {
  //         const res = await discountStatusChange({
  //           ids: id,
  //           status,
  //         });
  //         return { res, payload: { id, status } };
  //       },
  //       onSuccess: ({ res, payload }) => {
  //         if (res?.status !== 200) {
  //           updateData((pre) => {
  //             pre.data = (pre?.data || []).map((elm) =>
  //               elm?._id === payload?.id
  //                 ? { ...elm, status: payload?.status === 1 ? 2 : 1 }
  //                 : elm
  //             );
  //             return { ...pre };
  //           });
  //         }
  //       },
  //       onError: (error) => {
  //         console.log(error);
  //       },
  //     });

  const tableHeadData = [
    {
      _id: 1,
      name: "Name",
      align: "left",
    },
    {
      _id: 2,
      name: "Email",
      align: "left",
    },
    {
      _id: 3,
      name: "Type",
      align: "left",
    },
    {
      _id: 4,
      name: "Description",
      align: "left",
    },
    {
      _id: 5,
      name: "Website",
      align: "left",
    },
    {
      _id: 6,
      name: "Verified",
      align: "left",
    },
    {
      _id: 7,
      name: "Suspended",
      align: "left",
    },
    {
      _id: 8,
      name: "Action",
      align: "left",
    },
  ];

  // Table Body Data =====================>
  const tableData = data?.data?.map((item) => {
    return {
      _id: item?._id,
      rowData: [
        {
          _id: 1,
          type: "user",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.name || "-",
          image: item?.logo?.url,
          isTooltip: false,
        },
        {
          _id: 2,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.contactEmail,
        },
        {
          _id: 3,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.type || "-",
        },
        {
          _id: 4,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data:
            item?.description?.length > 25
              ? `${item.description.slice(0, 25)}...`
              : item?.description || "-",
        },
        {
          _id: 5,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.website,
        },
        {
          _id: 6,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.verified ? "Yes" : "No" || "-",
        },
        {
          _id: 7,
          type: "text",
          align: "left",
          cellClass: "!min-w-[100px]",
          data: item?.isSuspended ? "Yes" : "No",
        },
        {
          _id: 9,
          type: "action",
          align: "left",
          cellClass: "w-[5%]",
          actionData: [
            {
              _id: 9.1,
              name: "Edit",
              icon: "fa-regular fa-pen-to-square",
              onClick: () => {
                setModalOpen({ isOpen: true, data: item });
              },
              standout: false,
            },
            {
              _id: 9.2,
              name: "Delete",
              icon: "fa-regular fa-trash-can",
              standout: true,
              onClick: () => {
                setDeleteModal({
                  isOpen: true,
                  data: item,
                });
              },
            },
          ],
        },
      ],
    };
  });

  // add or edit page =================>
  function pageManageResponse(res) {
    if (res?.status === 200 || res?.status === 201) {
      if (res?.status === 201) {
        if (filters?.page === 1) {
          queryClient.setQueryData(
            ["organization", filters, search],
            (state) => {
              if (state) {
                let stateData = JSON.parse(JSON.stringify(state?.data));
                stateData = [...stateData, res?.data];
                return { ...state, data: stateData };
              }
            }
          );
          if (data?.metadata?.totalDocs > filters?.limit) {
            queryClient.invalidateQueries(["organization", filters, search]);
          }
        } else {
          setFilters((pre) => ({ ...pre, page: 1 }));
        }
      }
      if (res?.status === 200) {
        queryClient.setQueryData(["organization", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.map((item) =>
              item?._id === res?.data?._id ? { ...item, ...res?.data } : item
            );
            return { ...state, data: stateData };
          }
        });
        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["organization", filters, search]);
        }
      }
      setModalOpen({ isOpen: false, data: null });
    } else {
      toast.warning(res?.message || res?.error);
    }
  }

  //   banner delete handler =================>
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (payload) => {
      const res = await organizationDelete({
        ids: Array.isArray(payload) ? payload : [payload],
      });
      return {
        res,
        payload: Array.isArray(payload) ? payload : [payload],
      };
    },
    onSuccess: ({ res, payload }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        queryClient.setQueryData(["organization", filters, search], (state) => {
          if (state) {
            let stateData = JSON.parse(JSON.stringify(state?.data));
            stateData = stateData?.filter(
              (item) => !payload?.includes(item?._id)
            );

            return { ...state, data: stateData };
          }
        });

        if (data?.metadata?.totalDocs > filters?.limit) {
          queryClient.invalidateQueries(["organization", filters, search]);
        }
      } else {
        toast.warning(res?.message || res?.error);
      }
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <div className="space-y-4 w-full flex flex-col pb-10">
      <div className="space-y-8">
        <div className="font-bold text-center text-lg xl:text-3xl text-primary">
          Organization Management
        </div>
        <div className="flex items-center gap-3">
          <div className="w-36">
            <LimitSelect
              value={filters?.limit}
              allValue={data?.metadata?.totalDocs}
              onChange={(val) => handleFilterChange("limit", val, setFilters)}
            />
          </div>
          <div className="w-72">
            <Search
              placeholder={"Search here"}
              search={(val) => {
                setKeyword(val);
                handleFilterChange("page", 1, setFilters);
              }}
            />
          </div>
          <div className="relative">
            <Button
              buttonClasses={
                "!bg-transparent border border-transparent !h-10 hover:!bg-primary/10 hover:!border-primary/10"
              }
              buttonLabel={"Create New"}
              buttonLabelClasses={"font-medium !text-sm text-primary"}
              buttonHasLink
              buttonFunction={() => setModalOpen({ isOpen: true, data: null })}
            />
          </div>
        </div>
      </div>
      <Table
        tableHeadData={tableHeadData}
        tableData={tableData}
        isLoder={isLoading}
        pageCount={data?.metadata?.totalPages}
        currentPage={filters?.page}
        onPageChange={(val) => {
          handleFilterChange("page", val, setFilters);
          setSelectedItems([]);
        }}
        handleOrdering={(val) => {
          console.log(val);
        }}
        isFetching={isFetching}
        isOrderingDisabled={true}
        selectedItems={selectedItems}
        setSelectedItems={setSelectedItems}
        tableActionDropdownContainer={"!w-48"}
      />
      <ManageOrganizationDrawer
        open={modalOpen?.isOpen}
        data={modalOpen?.data}
        close={() => setModalOpen({ isOpen: false, data: null })}
        getResponse={pageManageResponse}
      />
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal((pre) => ({ data: null, isOpen: false }))}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </div>
  );
};

export default Organization;
